<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="calculator-field-config">
		<cbs-input
			name="calculation"
			v-validate="'required'"
			v-model="localCalExpValue"
			class="calculator-field-config__input w-full"
			:data-vv-as="$t('FieldConfig.Calculation')"
			:placeholder="`${$t('Actions.Input')} ${$t('FieldConfig.Calculation').toLowerCase()}`"
		/>
		<span class="text-danger text-sm">{{ errors.first("calculation") }}</span>

		<div class="info calculator-field-config__info bg-gray-6 p-3 mt-3 rounded">
			<div class="info__result" v-if="calculation">
				<span>{{ $t("FieldConfig.CalculationFormat") }}:</span>
				{{ calculation }}
			</div>

			<div class="info__list-fields">
				<span>{{ $t("FieldConfig.ListFormFieldsSupportCalculation") }}:</span>
				<ul v-if="listFields && listFields.length" class="pl-3 ">
					<li v-for="(field, index) in listFields" :key="index" :class="[{ 'inline-block mr-6': field.control != $constant.request.control.repeater }]">
						<div v-if="field.control === $constant.request.control.repeater && field.children && field.children.length > 0">
							<p class="font-medium">+ {{ field.title }}:</p>
							<div class="">
								<div class="inline-block mr-6" v-for="(chil, idx) in field.children" :key="`repeaterChil${idx}`">
									<p v-if="chil.control === $constant.request.control.number || chil.control === $constant.request.control.calculator">
										{{ `_${chil.id}: ${chil.title}` }}
									</p>
								</div>
							</div>
						</div>
						<p v-else>
							{{ `_${field.id}: ${field.title}` }}
						</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "lodash";

export default {
	inheritAttrs: false,
	inject: ["parentValidator"],
	name: "CalculatorFieldConfig",
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => prop.hasOwnProperty("cal_exp")
		},
		listFields: {
			type: Array,
			required: true,
			validator: prop => prop.every(item => _.has(item, "id") && _.has(item, "title"))
		}
	},
	computed: {
		calculation() {
			let rexStr = this.localCalExpValue || "";
			this.listFields.forEach(field => {
				let repStr = "_" + field.id;
				let re = new RegExp(repStr, "g");
				if (field.control === this.$constant.request.control.repeater) {
					field.children.map(chil => {
						if (chil.control === this.$constant.request.control.number) {
							repStr = "_" + chil.id;
							re = new RegExp(repStr, "g");
							rexStr = rexStr.replace(re, chil.title);
						}
					});
				} else {
					repStr = "_" + field.id;
				}
				rexStr = rexStr.replace(re, field.title);
			});
			return rexStr;
		},
		localCalExpValue: {
			get() {
				return this.value.cal_exp;
			},
			set(val) {
				this.$emit("input", { ...this.value, cal_exp: val });
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss" scoped>
.calculator-field-config {
	.info__list-fields {
		li {
			flex: 50%;
		}
	}
}
</style>
